export const Access = {
  lineItemFilter: 'line-item-filter',
  broadcast: 'broadcast',
  bulkOptimizerSettingUpdate: 'bulk-optimizer-update-ui',
  companyDashboard: 'company-dashboard',
  searchWithoutCompanySelected: 'search-without-company-selected',
  powerPointDownload: 'power-point-download',
  tritonAudioTopStation: 'triton-audio-top-stations',
  jelliTtwnPremiere: 'jelli-ttwn-premiere',
  companyJelliTtwnPremiere: 'company-jelli-ttwn-premiere',
  bundleDashboardReportTray: 'bundle-dashboard-report-tray',
  campaignDashboardReportTray: 'campaign-dashboard-report-tray',
  companyDashboardReportTray: 'company-dashboard-report-tray',
  viewScheduledReports: 'view-scheduled-reports',
  createScheduledReports: 'create-scheduled-reports',
  canGetMaxAndMinImpressions: 'min-and-max-impressions',
  broadcastJelliLdFlagEnableInIhmDash: 'jelli-in-initiative-group-dashboard',
  broadcastPremiereLdFlagEnableInIhmDash: 'premiere-in-initiative-group-dashboard',
  broadcastTtwnLdFlagEnableInIhmDash: 'ttwn-in-initiative-group-dashboard',
  salesDashboard: 'sales-dashboard-mvp',
  dealDashboard: 'deal-dashboard',
  amazonReachAndFrequencyLdFlagEnableInIhmDash: 'amazon-reach-and-frequency-in-dash',
  dcmInIhmDash: 'dcm-in-ihm-dash',
  powerPointV2Download: 'powerpoint-template-poc',
  hasPlaceIQEnableInIhmDash: 'place-iq-in-dash',
  groundtruthBroadcastFootprint: 'gt-broadcast-attribution',
  groundtruthDigitalFootprint: 'gt-foot-traffic-in-ihm-dash',
  googleAnalyticsCampaignDashLink: 'google-analytics-campaign-dash-link',
  searchTrendInCompanyDash: 'search-in-company-dash',
  hasSaleAgentChatInDash: 'sales-agent-in-ihm-dash',
  nationalPPTRecapUpdates: 'national-ppt-recap-updates',
  pptRecapLocalUpdate: 'ppt-recap-local-update',
  beeswaxTotalAudioInDash: 'beeswax-total-audio-in-dash',
  groundtruthDoohInDash: 'groundtruth-dooh-in-dash',
  vistarDoohInCampaignDash: 'vistar-dooh-in-campaign-dash',
  spotifyInCampaignDash: 'spotify-in-campaign-dash',
  ianAmazonInCampaignDash: 'ian-amazon-in-campaign-dash',
  iheartPodcastAmazonShopperSignalInDash: 'iheart-podcast-amazon-shopper-signal-in-dash',
  broadcastGrpsInDash: 'broadcast-grps-in-dash',
  pptRecapCompanyBundle: 'ppt-recap-company-bundle',
  commandCenterDashboard: 'cmcc-in-ihm-dash',
  downloadAllCsvInIhmDash: 'bulk-csv-export-in-dash',
  platformSearchInDash: 'cm-fulltext-search-in-ihm-dash',
  magellanReachFrequencyInIhmDash: 'magellan-reach-frequency-in-ihm-dash',
  spotlightDashboardInDash: 'spotlight-in-ihm-dash',
  digitalAdSpendInIhmDash: 'digital-ad-spend-in-ihm-dashboard',
} as const

export type Access = (typeof Access)[keyof typeof Access]

export interface AccessService {
  canAccess(access: Access): Promise<boolean>
}

export default AccessService
